import React from 'react';
import DocumentWorkspace from '../../components/document/DocumentWorkspace';

/**
 * Editor page component
 * 
 * @returns {JSX.Element} - Rendered component
 */
function EditorPage() {
  return (
    <div className="editor-page">
      <h1>Document Editor</h1>
      <DocumentWorkspace />
    </div>
  );
}

export default EditorPage;
